<template>
  <el-form
    ref="ruleForm"
    :model="item"
    label-position="left"
    label-width="160px"
  >
    <el-form-item
      label="Background Image"
      prop="background_image_url"
      :rules="[
        ...imageSizeRule(limited_size.background_image),
        ...urlRule('image_url'),
      ]"
    >
      <file-input
        accept="image/jpeg, image/png, image/gif"
        v-model="item.background_image_url"
        :check_upload_image_size="{
          ...limited_size.background_image,
          enable: true,
        }"
      ></file-input>
    </el-form-item>
    <el-tabs v-model="tab" type="card" tab-position="top">
      <el-tab-pane
        v-for="(num, index) in CONSTANT.CREATIVE_DEFAULT_VALUE.ROLLING_CASTLE
          .MIN_NUM"
        :key="num"
        :label="num.toString()"
        :name="num.toString()"
      >
        <el-divider>
          <span class="pink">Card</span>
        </el-divider>
        <el-form-item
          label="Image"
          :prop="`cards.${index}.image_url`"
          :rules="[
            ...imageSizeRule(limited_size.card_image),
            ...urlRule('image_url'),
          ]"
          label-width="80px"
        >
          <file-input
            accept="image/jpeg, image/png, image/gif"
            v-model="item.cards[index].image_url"
            :check_upload_image_size="{
              ...limited_size.card_image,
              enable: true,
            }"
          ></file-input>
        </el-form-item>
        <el-form-item label="Bottom Offset" label-width="120px">
          <Offset v-model="item.offset_bottom"> </Offset>
        </el-form-item>
        <el-divider>
          <span class="pink">Banner</span>
        </el-divider>
        <el-form-item label="Type">
          <el-radio-group v-model="item.banners[index].type">
            <el-radio label="image">Image</el-radio>
            <el-radio
              label="video"
              :disabled="video_index !== -1 && video_index !== index"
              >Video</el-radio
            >
          </el-radio-group>
        </el-form-item>
        <el-form-item
          label="Landing Page"
          :prop="`banners.${index}.landing_page`"
          :rules="urlRule('landing_page')"
          label-width="120px"
        >
          <el-input v-model="item.banners[index].landing_page"></el-input>
        </el-form-item>
        <div v-if="item.banners[index].type === 'image'">
          <form-item-group
            title="Images"
            :min="CONSTANT.CREATIVE_DEFAULT_VALUE.ROLLING_CASTLE.IMAGE.MIN_NUM"
            :max="CONSTANT.CREATIVE_DEFAULT_VALUE.ROLLING_CASTLE.IMAGE.MAX_NUM"
            :group-item="
              CONSTANT.CREATIVE_DEFAULT_VALUE.ROLLING_CASTLE.IMAGE.ITEM.FG
            "
            v-model="item.banners[index].images"
            :delete-index="1"
          >
            <template slot-scope="scope">
              <el-form-item
                label="Image"
                :prop="`banners.${index}.images.${scope.index}.url`"
                :rules="[
                  ...imageSizeRule(limited_size.banner_image),
                  ...urlRule('image_url'),
                ]"
                label-width="120px"
              >
                <file-input
                  accept="image/jpeg, image/png, image/gif"
                  v-model="item.banners[index].images[scope.index].url"
                  :check_upload_image_size="{
                    ...limited_size.banner_image,
                    enable: true,
                  }"
                ></file-input>
              </el-form-item>
              <el-form-item
                label="Size"
                :prop="`banners.${index}.images.${scope.index}.width`"
                :rules="numberRule(`image_size`)"
                label-width="80px"
                v-if="scope.index > 0"
              >
                <el-row type="flex" :gutter="10">
                  <el-col :span="20">
                    <el-slider
                      v-model="item.banners[index].images[scope.index].width"
                      :marks="{ 50: '50%' }"
                      show-input
                      input-size="mini"
                    ></el-slider>
                  </el-col>
                  <el-col :span="4">
                    <el-checkbox
                      v-model="item.banners[index].images[scope.index].is_float"
                      border
                      >Float</el-checkbox
                    >
                  </el-col>
                </el-row>
              </el-form-item>
              <layout-item
                v-for="key in ['vertical', 'horizontal']"
                :key="key"
                :label="_.startCase(key)"
                :prop="`banners.${index}.images.${scope.index}`"
                :type="key"
                :min="0"
                :max="50"
                v-model="item.banners[index].images[scope.index][key]"
                v-if="scope.index > 0"
              >
                <template #padding>
                  <el-slider
                    v-model="
                      item.banners[index].images[scope.index][key].padding
                    "
                    :max="50"
                    :marks="{ 25: '25%' }"
                    input-size="mini"
                    :disabled="
                      item.banners[index].images[scope.index][key].align ===
                        'center'
                    "
                  ></el-slider>
                </template>
              </layout-item>
            </template>
          </form-item-group>
        </div>

        <video-item
          ref="video"
          replay
          v-if="item.banners[index].type === 'video'"
        ></video-item>
      </el-tab-pane>
    </el-tabs>
  </el-form>
</template>

<script>
import MixFormRule from "@/components/mixins/formRule";
import MixCreativeForm from "@/components/mixins/creativeForm";

const { ROLLING_CASTLE } = CONSTANT.CREATIVE_DEFAULT_VALUE;

const CARDS_ITEM = {
  image_url: "",
};

const BANNERS_ITEM = {
  type: "image",
  landing_page: "",
  images: [_.cloneDeep(ROLLING_CASTLE.IMAGE.ITEM.BG)],
};

export default {
  data() {
    return {
      tab: "1",
      item: {
        background_image_url: "",
        cards: [...Array(ROLLING_CASTLE.MIN_NUM)].map(() =>
          _.cloneDeep(CARDS_ITEM)
        ),
        banners: [...Array(ROLLING_CASTLE.MIN_NUM)].map(() =>
          _.cloneDeep(BANNERS_ITEM)
        ),
        offset_bottom: {
          number: "",
          unit: "px",
        },
      }, // for banner
      limit: {
        min_num: ROLLING_CASTLE.MIN_NUM,
        max_num: ROLLING_CASTLE.MAX_NUM,
      },
      limited_size: {
        background_image: {
          width: {
            max: 640,
            min: 640,
          },
          height: {
            max: 1138,
            min: 1138,
          },
        },
        card_image: {
          width: {
            max: 300,
            min: 300,
          },
          height: {
            max: 180,
            min: 180,
          },
        },
        banner_image: {
          width: {
            max: 640,
            min: 640,
          },
          height: {
            max: 1138,
            min: 1138,
          },
        },
      },
    };
  },
  computed: {
    video_index() {
      return this.item.banners.findIndex((banner) => banner.type === "video");
    },
  },
  mixins: [MixFormRule, MixCreativeForm],
  methods: {
    async setData(row) {
      this.item.background_image_url = decodeURI(row.background_image_url);
      this.item.cards = _.map(row.cards, (card) => ({
        image_url: decodeURI(card.image_url),
      }));
      this.item.banners = _.map(row.banners, (banner, index) => {
        let obj = {
          type: banner.type,
          landing_page: decodeURI(banner.landing_page),
        };
        if (banner.type === "image") {
          obj.images = _.map(banner.images, (image, img_index) => {
            if (image.type === "bg") {
              return image;
            } else {
              return {
                type: image.type,
                url: decodeURI(image.url),
                width: image.width,
                is_float: image.is_float,
                vertical: {
                  align: image.vertical_align,
                  padding: image.vertical_padding,
                },
                horizontal: {
                  align: image.horizontal_align,
                  padding: image.horizontal_padding,
                },
              };
            }
          });
        } else if (banner.type === "video") {
          obj.images = [_.cloneDeep(ROLLING_CASTLE.IMAGE.ITEM.BG)];
        }
        return obj;
      });
      this.item.offset_bottom.unit = row.offset_bottom_unit;
      this.item.offset_bottom.number = row.offset_bottom_number;
      if (this.video_index !== -1) {
        await this.$nextTick();
        this.$refs.video[0].setData(row.banners[this.video_index]);
      }
    },
    async getData(setObj) {
      setObj.background_image_url = this.item.background_image_url.replace(/[^\x00-\x7F]/g, (c) => encodeURI(c));
      setObj.cards = _.map(this.item.cards, (card) => ({
        image_url: card.image_url.replace(/[^\x00-\x7F]/g, (c) => encodeURI(c)),
      }));
      setObj.banners = _.map(this.item.banners, (banner) => {
        let obj = {
          type: banner.type,
          landing_page: banner.landing_page.replace(/[^\x00-\x7F]/g, (c) => encodeURI(c)),
        };
        if (banner.type === "image") {
          obj.images = _.map(banner.images, (image) => {
            return image.type === "bg"
              ? image
              : {
                  type: image.type,
                  url: image.url.replace(/[^\x00-\x7F]/g, (c) => encodeURI(c)),
                  width: image.width,
                  is_float: image.is_float,
                  vertical_align: image.vertical.align,
                  vertical_padding: image.vertical.padding,
                  horizontal_align: image.horizontal.align,
                  horizontal_padding: image.horizontal.padding,
                };
          });
        }
        return obj;
      });
      setObj.offset_bottom_unit = this.item.offset_bottom.unit;
      setObj.offset_bottom_number = this.item.offset_bottom.number;
      if (this.video_index !== -1) {
        setObj.banners[this.video_index] = await this.$refs.video[0].getData(
          setObj.banners[this.video_index],
          640,
          1138
        );
      }

      return setObj;
    },
  },
};
</script>

<style></style>
